module.exports = __webpack_public_path__ + "static/media/DSC08893_180531_2.1df80dee.jpg";